const config = require("../config")
const url = config.base_dev_url + "z_farm_work_record_cost"

module.exports = {
    listByOrderId: {
        url: url + "/listByOrderId",
        type: "get",
    },
    getByRecordId: {
        url: url + "/getByRecordId",
        type: "get",
    },
    selectQuote: {
        url: url + "/selectQuote",
        type: "post",
    },
}